import React, { Component } from "react";
import { connect } from "react-redux";
import TopBarMessageList from "./top-bar-message-list";
import "./main-bar.scss";
import "../../styles/main.scss";

export class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const props = this.props;
    const {
      sideBarToggle,
      selectedMessages,
      selectedMessagesAllUnread
    } = props;
    const collapsed = props.sideBarCollapsed;
    const title = props.title;

    return (
      <header
        className={`mainBar
      ${collapsed ? "" : "with-side-bar"}
      ${"mdc-top-app-bar"} ${"mdc-top-app-bar--fixed"} ${
        this.props.showSearchEvents ? "calendarHeader" : "mailHeader"
      }`}
      >
        <TopBarMessageList
          title={title}
          collapsed={collapsed}
          sideBarToggle={sideBarToggle}
          selectedMessages={selectedMessages}
          onDeleteClick={() => this.onDelete(props.deleteMessages)}
          selectedMessagesAllUnread={selectedMessagesAllUnread}
          onMarkReadClick={() => props.setMessagesSeen(true)}
          onMarkUnreadClick={() => props.setMessagesSeen(false)}
          hiddeSearch={this.props.hiddeSearch}
          showSearchEvents={this.props.showSearchEvents}
          isEmail={true}
        />
      </header>
    );
  }
}

export default connect()(TopBar);
